import React from 'react';
import styled from 'styled-components';
import { relativeAgo } from './commons';

export default function AgoChip({ date, className }) {
    return <Chip className={className}>{relativeAgo(date)}</Chip>;
}

const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    font-size: 0.68rem;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 20px;
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
    white-space: nowrap;
`;
